import { DataTable } from '@pihealth/common-ui-library';
import SIVFollowupLetter from './SIVFollowupLetter';
import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect, useState } from 'react';
import { useSIVFollowupLetter } from './useSIVFollowupLetter';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useUser } from 'src/components/hooks/useUser';
import VersionHistory from 'src/components/common/VersionHistory';
import staticData from '../../../../resources/static.json';
import { archLevel } from 'src/data/config';
import { setMessage } from 'src/store/Message';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
export function SIVFollowupTable({ siteStudyPersonnelsData, setSIVFollowupLetterOpen, setStudyLogOpen }: any) {
  const [openLetter, setOpenLetter] = useState(true);
  const { getSivFollowupLetter, sivFollowupLetterIsLoading } = useSIVFollowupLetter();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const [rows, setRows] = useState([]);
  const [visitData, setVisitData] = useState<any>([]);
  const { preferences } = useUser();
  const [headerTitle, setHedertitle] = useState('');
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [docId, setDocId] = useState('');
  const assignedColoumns = staticData.SQLetters.columns;
  const dispatch = useAppDispatch();
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const versionClick = (versionData: any) => {
    setHedertitle(versionData.visit_name);
    setDocId(versionData.tp_document_id);
    setShowVersionHistory(true);
  };

  const handleClick = (data: any) => {
    if (archLevel === 'site') {
      if (data.major_version === '0.0') {
        dispatch(setMessage({ msgDetails: `${data.visit_name} not yet published`, severity: 'error' }));
      } else {
        if (!isHierarchyLevelClosed) {
          setVisitData([data]);
          setOpenLetter(false);
        } else {
          dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
        }
      }
    } else {
      if (!isHierarchyLevelClosed) {
        setVisitData([data]);
        setOpenLetter(false);
      } else {
        dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
      }
    }
  };

  const actions = {
    visit_name: (data: any) => {
      handleClick(data);
    },
    major_version: (data: any) => {
      versionClick(data);
    }
  };
  const handleBack = () => {
    setSIVFollowupLetterOpen(false);
    setStudyLogOpen(true);
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`SIV Follow-Up Letters`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  const followupData = async () => {
    const allFollowupData: any = await getSivFollowupLetter({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry
    });

    if (allFollowupData.isSuccess) {
      const tempRows: any = [];
      allFollowupData?.data.map((data: any) => {
        tempRows.push({
          ...data,
          start_date: getPreferredDateTimeInLocal(data.start_date),
          updated_on: getPreferredDateTimeInLocal(data.updated_on),
          major_version: Number(data.major_version).toFixed(1).toString()
        });
      });

      if (tempRows.length > 0) {
        setRows(tempRows);
      }
    } else if (allFollowupData?.isError) {
      setRows([]);
    }
  };

  useEffect(() => {
    followupData();
  }, [openLetter, selectedSite, selectedCountry]);
  return (
    <>
      {openLetter ? (
        <>
          <Box className="mainBackBtnWrap">
            <Button onClick={handleBack} startIcon={<ArrowBackIcon fontSize="small" />}>
              LIST OF LOGS
            </Button>
          </Box>
          <DataTable
            columns={assignedColoumns}
            rows={rows}
            actions={actions}
            datePreference={preferences?.date_format ? preferences?.date_format : 'MM/dd/yyyy'}
            loading={sivFollowupLetterIsLoading}
            disableSelectionOnClick={false}
            pagination
            className="studylogDatagrid"
            exportAll
            height="74vh"
            hasDefinedDataGridToolbarExport
            definedGridToolbarExport={definedCustomDatGridExport}
          />
          {showVersionHistory ? (
            <VersionHistory
              openVersoinHistory={showVersionHistory}
              setOpenVersoinHistory={setShowVersionHistory}
              title={headerTitle}
              documentId={docId}
              auditModuleSection={'SIV FOLLOWUP'}
            />
          ) : (
            ''
          )}
        </>
      ) : (
        <SIVFollowupLetter
          siteStudyPersonnelsData={siteStudyPersonnelsData}
          sivVisitData={visitData}
          setSIVFollowupLetterOpen={setSIVFollowupLetterOpen}
          setOpenLetter={setOpenLetter}
          setStudyLogOpen={setStudyLogOpen}
        />
      )}
    </>
  );
}
